<ul class="text-sm font-medium text-center text-body flex -space-x-px sm:hidden mb-4">
  @for (grade of selectionStore.grades(); track grade.key) {
    <li class="w-full focus-within:z-10">
      <div (click)="scrollToTarget(grade.key)"
           class="inline-block w-full bg-neutral-primary-soft border-y border-default rounded-s-base hover:bg-neutral-secondary-medium hover:text-heading focus:ring-4 focus:ring-neutral-secondary-strong font-medium leading-5 text-sm px-1 py-1 focus:outline-none"
           [class.rounded-s-base]="$first"
           [class.rounded-e-base]="$last"
           [class.border-s]="$first"
           [class.border-e]="$last"
      >
        <div [class.bg-brand]="selected() ? selected() === grade.key : $last" [class.text-white]="selected() ? selected() === grade.key : $last" class="rounded-md px-2 py-1.5">
          {{ grade.key | titlecase }}
        </div>
      </div>
    </li>
  }
</ul>

<div
  #scrollContainer
  class="flex md:justify-evenly gap-4 md:gap-12 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none scrollbar-hide">
  @for (grade of selectionStore.grades(); track grade.key) {
    <div class="w-full md:w-1/4 flex-shrink-0 snap-center" id="{{grade.key}}">
      <app-selection-item [level]="grade.key" [item]="grade.data.item" [addons]="grade.data.addons"
                          [maxAddonRows]="maxAddonRows()" [maxFeeRows]="maxFeeRows()"/>
    </div>
  }
</div>
